import React from "react";
import { Pie, PieChart, Tooltip, ResponsiveContainer } from "recharts";

const ConnectionChart = ({ connectedToAI, notConnectedToAI, connectionRate }) => {
  const total = (connectedToAI || 0) + (notConnectedToAI || 0);

  if (total === 0) {
    return (
      <div className="graph-container">
        <h4 className="graph-header">AI Connection</h4>
        <div style={{ textAlign: "center", padding: "40px", color: "#888" }}>
          No connection data available
        </div>
      </div>
    );
  }

  const data = [
    { label: "Connected", value: connectedToAI || 0, fill: "#4caf50" },
    { label: "Not Connected", value: notConnectedToAI || 0, fill: "#9e9e9e" }
  ].filter(d => d.value > 0);

  return (
    <div className="graph-container">
      <h4 className="graph-header">AI Connection</h4>
      <ResponsiveContainer height={250}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="label"
            isAnimationActive={false}
          />
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "10px", marginTop: "10px" }}>
        {data.map((item, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <div style={{ width: "12px", height: "12px", backgroundColor: item.fill, borderRadius: "2px" }} />
            <span style={{ fontSize: "12px" }}>{item.label}: {item.value}</span>
          </div>
        ))}
        <span style={{ fontSize: "12px", color: "#666" }}>({connectionRate || 0}% connected)</span>
      </div>
    </div>
  );
};

export default ConnectionChart;
